import { render, staticRenderFns } from "./cliente-form.vue?vue&type=template&id=fdce41ea&scoped=true&"
import script from "./cliente-form.vue?vue&type=script&lang=js&"
export * from "./cliente-form.vue?vue&type=script&lang=js&"
import style0 from "./cliente-form.vue?vue&type=style&index=0&id=fdce41ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdce41ea",
  null
  
)

export default component.exports